import { React, useState, useRef, useEffect, useMemo } from "react";
import AgentLayout from "../components/AgentLayout";
import axiosInstance from "../../../utils/axiosInstance";

const MarketPosition = () => {
  const [marketPosition, setMarketPosition] = useState(null);
  const [horse, setHorse] = useState(null);
  const [grayhounds, setGrayhounds] = useState(null);
  const [pageLoad, setPageLoad] = useState(false);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const fetchMarketPosition = async () => {
    try {
      const { data } = await axiosInstance.get(
        "/master/account-current-position"
      );

      const horseData = data?.horse || [];
      const { horse: horseItems, grayhounds: greyhoundItems } =
        horseData.reduce(
          (acc, item) => {
            if (item.bet_game_type === 4) acc.horse.push(item);
            if (item.bet_game_type === 5) acc.grayhounds.push(item);
            return acc;
          },
          { horse: [], grayhounds: [] }
        );

      setHorse(horseItems);
      setGrayhounds(greyhoundItems);
      setMarketPosition(data);
      setPageLoad(true);
    } catch (err) {
      console.error("Fetching error", err);
    }
  };

  useEffect(() => {
    let isMounted = true;
    let timeoutId;

    const fetchByTime = async () => {
      if (!isMounted) return;

      await fetchMarketPosition();

      timeoutId = setTimeout(fetchByTime, 30000);
    };

    fetchByTime();

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, []);

  const cricketDisplayRows = useMemo(() => {
    let cricket = marketPosition?.cricket;
    if (!cricket || cricket.length == 0) return [];

    let fancyByParent = {};
    let tieByParent = {};

    for (let i = 0; i < cricket.length; i++) {
      let item = cricket[i];
      if (item.EventType == "Fancy") {
        let parentMid = item.parent_cat_mid || item.CatMid;
        if (!fancyByParent[parentMid]) {
          fancyByParent[parentMid] = [];
        }
        fancyByParent[parentMid].push(item);
        continue;
      }
      if (item.EventType == "Tie") {
        let parentMid = item.parent_cat_mid || item.CatMid;
        tieByParent[parentMid] = item;
        continue;
      }
    }

    let displayRows = [];
    let insertedFancy = {};
    let insertedTie = {};

    for (let i = 0; i < cricket.length; i++) {
      let item = cricket[i];
      if (item.EventType == "Fancy" || item.EventType == "Tie") {
        continue;
      }

      displayRows.push(item);

      if (item.EventType == "MatchOdd" || item.EventType == "BookMaker") {
        let parentMid = item.CatMid;
        if (fancyByParent[parentMid] && !insertedFancy[parentMid]) {
          insertedFancy[parentMid] = true;
          for (let j = 0; j < fancyByParent[parentMid].length; j++) {
            displayRows.push(fancyByParent[parentMid][j]);
          }
        }
        if (tieByParent[parentMid] && !insertedTie[parentMid]) {
          insertedTie[parentMid] = true;
          displayRows.push(tieByParent[parentMid]);
        }
      }
    }

    for (let parentMid in fancyByParent) {
      if (insertedFancy[parentMid]) {
        continue;
      }
      for (let j = 0; j < fancyByParent[parentMid].length; j++) {
        displayRows.push(fancyByParent[parentMid][j]);
      }
    }

    for (let parentMid in tieByParent) {
      if (insertedTie[parentMid]) {
        continue;
      }
      displayRows.push(tieByParent[parentMid]);
    }

    return displayRows;
  }, [marketPosition?.cricket]);

  const getCricketRowLabel = (item) => {
    if (item.EventType == "Fancy") {
      if (item.Name && item.Name.indexOf(" / ") >= 0) {
        let parts = item.Name.split(" / ");
        return parts[0] + "/" + parts.slice(1).join(" / ");
      }
      return item.Name;
    }
    if (item.EventType == "Tie") {
      let matchName = item.Name;
      if (matchName && matchName.indexOf(" / ") >= 0) {
        matchName = matchName.split(" / ")[0];
      }
      return matchName + "/Tie";
    }
    return item.Name + "/" + item.EventType;
  };

  const getCricketRowLink = (item) => {
    if (item.EventType == "Fancy" || item.EventType == "Tie") {
      return item.parent_cat_mid || item.CatMid;
    }
    return item.CatMid;
  };

  return (
    <AgentLayout>
      <div class="animated fadeIn">
        <div class="row" style={{ padding: "6px" }}>
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <strong class="site_family"> Market Position </strong>
                <a class="btn btn-sm btn-primary" onClick={fetchMarketPosition}>
                  <strong style={{ color: "white" }} class="site_family">
                    Refresh
                  </strong>
                </a>
              </div>
              {marketPosition && (
                <div class="card-body" style={{ padding: "13px" }}>
                  <div style={{ margin: "5px" }}>
                    {marketPosition?.cricket?.length > 0 && (
                      <table
                        style={{ width: "100%" }}
                        class="table table-bordered table-striped table-sm"
                      >
                        <tbody>
                          <tr>
                            <th class="site_family">Cricket</th>
                            <th
                              style={{
                                width: "20%"
                              }}
                              class="site_family"
                            >
                              Amount
                            </th>
                          </tr>
                        </tbody>
                        <tbody>
                          {cricketDisplayRows.map((item, index) => (
                            <tr
                              key={index}
                              style={{
                                background: index % 2 == 0 ? "white" : "#f2f2f2"
                              }}
                            >
                              <td style={{ padding: "5px" }}>
                                <div style={{ float: "left" }}>
                                  <a
                                    href={`/agent/market-analysis/${getCricketRowLink(
                                      item
                                    )}`}
                                    style={{
                                      color: "#00b181",
                                      fontSize: "1.02275rem",
                                      fontWeight: 500,
                                      lineHeight: "1.2"
                                    }}
                                    class="site_family"
                                  >
                                    {getCricketRowLabel(item)}
                                  </a>
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: "5px",
                                  textAlign: "left"
                                }}
                                class="site_family"
                              >
                                <span
                                  style={{
                                    color: item.Amount < 0 ? "red" : "green"
                                  }}
                                >
                                  {formatTruncate(item.Amount)}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                    {marketPosition?.football?.length > 0 && (
                      <table
                        style={{ width: "100%" }}
                        class="table table-bordered table-striped table-sm"
                      >
                        <tbody>
                          <tr>
                            <th class="site_family">Soccer</th>
                            <th
                              style={{
                                width: "20%"
                              }}
                              class="site_family"
                            >
                              Amount
                            </th>
                          </tr>
                        </tbody>

                        <tbody id="footballTblList">
                          {marketPosition?.football?.map((item, index) => (
                            <tr
                              key={index}
                              style={{
                                background: index % 2 == 0 ? "white" : "#f2f2f2"
                              }}
                            >
                              <td style={{ padding: "5px" }}>
                                <div style={{ float: "left" }}>
                                  <a
                                    href={`/agent/market-analysis/${item.CatMid}`}
                                    style={{
                                      color: "#00b181",
                                      fontSize: "1.09375rem",
                                      fontWeight: 500
                                    }}
                                    class="site_family"
                                  >
                                    {item.Name}
                                  </a>
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: "7px",
                                  textAlign: "left"
                                }}
                                class="site_family"
                              >
                                <span
                                  style={{
                                    color: item.Amount < 0 ? "red" : "green"
                                  }}
                                >
                                  {formatTruncate(item.Amount)}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                    {marketPosition?.tennis?.length > 0 && (
                      <table
                        style={{ width: "100%" }}
                        class="table table-bordered table-striped table-sm"
                      >
                        <tbody>
                          <tr>
                            <th class="site_family">Tennis</th>
                            <th
                              style={{
                                width: "20%"
                              }}
                              class="site_family"
                            >
                              Amount
                            </th>
                          </tr>
                        </tbody>

                        <tbody id="tennisTblList">
                          {marketPosition?.tennis?.map((item, index) => (
                            <tr
                              key={index}
                              style={{
                                background: index % 2 == 0 ? "white" : "#f2f2f2"
                              }}
                            >
                              <td style={{ padding: "5px" }}>
                                <div style={{ float: "left" }}>
                                  <a
                                    href={`/agent/market-analysis/${item.CatMid}`}
                                    style={{
                                      color: "#00b181",
                                      fontSize: "1.09375rem",
                                      fontWeight: 500
                                    }}
                                    class="site_family"
                                  >
                                    {item.Name}
                                  </a>
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: "5px",
                                  textAlign: "left"
                                }}
                                class="site_family"
                              >
                                <span
                                  style={{
                                    color: item.Amount < 0 ? "red" : "green"
                                  }}
                                >
                                  {formatTruncate(item.Amount)}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                    {horse?.length > 0 && (
                      <table
                        style={{ width: "100%" }}
                        class="table table-bordered table-striped table-sm"
                      >
                        <tbody>
                          <tr style={{ background: "#fff !important" }}>
                            <td
                              style={{
                                border: "1px solid #c8ced3",
                                fontWeight: "bold",
                                padding: "5px",
                                width: "75%"
                              }}
                              class="site_family"
                            >
                              {" "}
                              Horse Race{" "}
                            </td>
                            <td
                              style={{
                                border: "1px solid #c8ced3",
                                fontWeight: "bold",
                                textAlign: "left",
                                padding: "5px"
                              }}
                              class="site_family"
                            >
                              {" "}
                              Amount{" "}
                            </td>
                          </tr>
                        </tbody>
                        <tbody id="horseRaceTblList">
                          {horse?.map((item, index) => (
                            <tr
                              key={index}
                              style={{
                                background: index % 2 == 0 ? "white" : "#f2f2f2"
                              }}
                            >
                              <td style={{ padding: "5px" }}>
                                <div style={{ float: "left" }}>
                                  <a
                                    href={`/agent/market-analysis/${item.CatMid}`}
                                    style={{
                                      color: "#00b181",
                                      fontSize: "1.09375rem",
                                      fontWeight: 500
                                    }}
                                    class="site_family"
                                  >
                                    {item.Name}
                                  </a>
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: "5px",
                                  textAlign: "left"
                                }}
                                class="site_family"
                              >
                                <span
                                  style={{
                                    color: item.Amount < 0 ? "red" : "green"
                                  }}
                                >
                                  {formatTruncate(item.Amount)}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}

                    {grayhounds?.length > 0 && (
                      <table
                        style={{ width: "100%" }}
                        class="table table-bordered table-striped table-sm"
                      >
                        <tbody>
                          <tr style={{ background: "#fff !important" }}>
                            <td
                              style={{
                                border: "1px solid #c8ced3",
                                fontWeight: "bold",
                                padding: "5px",
                                width: "75%"
                              }}
                              class="site_family"
                            >
                              {" "}
                              Grey Hound{" "}
                            </td>
                            <td
                              style={{
                                border: "1px solid #c8ced3",
                                fontWeight: "bold",
                                textAlign: "left",
                                padding: "5px"
                              }}
                              class="site_family"
                            >
                              {" "}
                              Amount{" "}
                            </td>
                          </tr>
                        </tbody>
                        <tbody id="greyHoundTblList">
                          {grayhounds?.map((item, index) => (
                            <tr
                              key={index}
                              style={{
                                background: index % 2 == 0 ? "white" : "#f2f2f2"
                              }}
                            >
                              <td style={{ padding: "5px" }}>
                                <div style={{ float: "left" }}>
                                  <a
                                    href={`/agent/market-analysis/${item.CatMid}`}
                                    style={{
                                      color: "#00b181",
                                      fontSize: "1.09375rem",
                                      fontWeight: 500
                                    }}
                                    class="site_family"
                                  >
                                    {item.Name}
                                  </a>
                                </div>
                              </td>

                              <td
                                style={{
                                  padding: "5px",
                                  textAlign: "left"
                                }}
                                class="site_family"
                              >
                                <span
                                  style={{
                                    color: item.Amount < 0 ? "red" : "green"
                                  }}
                                >
                                  {formatTruncate(item.Amount)}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            textAlign: "left",
            display: pageLoad ? "none" : "block"
          }}
        >
          <img src="../../assets/images/loadinggif.gif" alt="Loader" />
        </div>
        <style>
          {`

.table-striped tbody tr:nth-of-type(odd) {
   background-color: white;
}
 
`}
        </style>
      </div>
    </AgentLayout>
  );
};

export default MarketPosition;
